export default {"src":"/_next/static/media/digitial.bc4eeae4.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};